"use strict";

module.exports = function (accumulator, order, product, component) {
  var q = component.quantity;
  var up = parseInt(component.up, 10);

  if (q > up) {
    if (accumulator.length > 0) {
      return accumulator + ' - TWO SETS NEEDED FOR DEFECT CHECK';
    }

    return 'TWO SETS NEEDED FOR DEFECT CHECK';
  }

  return accumulator;
};